import { ErrorResponse } from "@design-controls/types";
import axios from "axios";
import { FieldValues, UseFormSetError } from "react-hook-form";

export function handleFormError<TFieldValues extends FieldValues = FieldValues>(
  error: any,
  setError: UseFormSetError<TFieldValues>,
) {
  if (axios.isAxiosError(error) && error.status === 400) {
    const response = ErrorResponse.parse(error.response?.data);
    response.errors.forEach((error) => {
      setError(error.field as any, { message: error.message[0] });
    });
  }

  return null;
}
